const init = () => {
    const wrapperShop = document.querySelector('.ns-wrapper--apm-finder-filter');

    if (!wrapperShop) {
        return;
    }

    const industry = document.querySelector('#filter-industry');
    const industryInput = industry.querySelector('.ns-singleselect__input');
    const industryTitle = industry.querySelector('.ns-singleselect__title');
    const targetRegion = document.querySelector('#filter-target-region');
    const targetRegionSelectInput = targetRegion.querySelector('.ns-multiselect__input');
    const targetRegionCheckboxInputs = targetRegion.querySelectorAll('.ns-checkbox__input');
    const targetCountry = document.querySelector('#filter-target-country');
    const paymentType = document.querySelector('#filter-payment-type');
    const buttonShowAllDesktop = wrapperShop.querySelector('.ns-shop__button-show-all_desktop');

    const industryMobile = document.querySelector('.ns-singleselect-mobile__frame[data-tag="industry"]');
    const industryMobileInputs = industryMobile.querySelectorAll('.ns-radio__input');
    const targetRegionMobile = document.querySelector('.ns-multiselect-mobile__frame[data-tag="targetRegion"]');
    const targetRegionMobileInputs = targetRegionMobile.querySelectorAll('.ns-checkbox__input');
    const targetCountryMobile = document.querySelector('#mobile-filter-target-country');
    const targetCountryFrameMobile = document.querySelector('.ns-multiselect-mobile__frame[data-tag="targetCountry"]');
    const targetCountryItemsMobile = targetCountryFrameMobile.querySelectorAll('.ns-multiselect-mobile__frame-list-item');
    const paymentTypeMobile = document.querySelector('#mobile-filter-payment-type');
    const paymentTypeFrameMobile = document.querySelector('.ns-multiselect-mobile__frame[data-tag="paymentType"]');
    const buttonShowAllMobile = wrapperShop.querySelector('.ns-shop__button-show-all_mobile');

    const containerMobile = document.querySelector(".ns-customer-stories-mobile-filter");

    let isFullFilter = false;

    const customControlsForKeyActivation =
        '.ns-multiselect-tab, ' +
        '.ns-multiselect-mobile__frame-tab, ' +
        '.ns-singleselect-mobile__frame-top-back, ' +
        '.ns-multiselect-mobile__frame-top-back, ' +
        '.ns-multiselect__select-all, ' +
        '.ns-multiselect__deselect-all, ' +
        '.ns-multiselect__confirm-selection, ' +
        '.ns-multiselect-mobile__frame-top-all-select, ' +
        '.ns-multiselect-mobile__frame-top-all-deselect'
    ;

    document.querySelectorAll(customControlsForKeyActivation).forEach(tab => {
        tab.addEventListener('keydown',(e)=>{
            if(e.code === "Enter" || e.code === "Space"){
                e.preventDefault();
                e.target.click();
            }
        });
    });

    industry.addEventListener('change', () => {
        if (industryInput.value && targetRegionSelectInput.value) {
            targetCountry.classList.remove('ns-multiselect--disabled');
            targetCountry.removeAttribute('inert');
            paymentType.classList.remove('ns-multiselect--disabled');
            paymentType.removeAttribute('inert');
            buttonShowAllDesktop.classList.remove('ns-button_disabled');
            buttonShowAllDesktop.removeAttribute('inert');
            isFullFilter = true;
            getPaymentMethods();
        } else {
            targetCountry.classList.add('ns-multiselect--disabled');
            targetCountry.setAttribute('inert', 'true');
            paymentType.classList.add('ns-multiselect--disabled');
            paymentType.setAttribute('inert', 'true');
            isFullFilter = false;
        }
    });

    targetRegion.addEventListener('change', () => {
        for (const targetRegionCheckboxInput of targetRegionCheckboxInputs) {
            const targetCountryTabRegions = targetCountry.querySelector(
                `.ns-multiselect__regions li[data-region='${targetRegionCheckboxInput.value}']`
            );
            const targetCountryInputs = targetCountry.querySelectorAll(
                `.ns-multiselect__list li[data-region='${targetRegionCheckboxInput.value}'] input`
            );

            if (targetRegionCheckboxInput.checked) {
                targetCountryTabRegions.classList.remove('ns-multiselect__region--off');

                for (const targetCountryInput of targetCountryInputs) {
                    if (!targetCountryInput.checked) {
                        targetCountryInput.click();
                    }
                }
            } else {
                targetCountryTabRegions.classList.add('ns-multiselect__region--off');

                for (const targetCountryInput of targetCountryInputs) {
                    if (targetCountryInput.checked) {
                        targetCountryInput.click();
                    }
                }
            }
        }

        const targetCountryFirstTabRegion =
            targetCountry.querySelector(`.ns-multiselect__regions li:not(.ns-multiselect__region--off)`);

        if (targetCountryFirstTabRegion) {
            targetCountryFirstTabRegion.click();
        }

        targetRegion.querySelector('.ns-multiselect__title').click();

        if (industryInput.value && targetRegionSelectInput.value) {
            targetCountry.classList.remove('ns-multiselect--disabled');
            targetCountry.removeAttribute('inert');
            paymentType.classList.remove('ns-multiselect--disabled');
            paymentType.removeAttribute('inert');
            buttonShowAllDesktop.classList.remove('ns-button_disabled');
            buttonShowAllDesktop.removeAttribute('inert');
            isFullFilter = true;
            getPaymentMethods();
        } else {
            buttonShowAllDesktop.classList.add('ns-button_disabled');
            buttonShowAllDesktop.setAttribute('inert', 'true');
            paymentType.classList.add('ns-multiselect--disabled');
            paymentType.setAttribute('inert', 'true');
            targetCountry.classList.add('ns-multiselect--disabled');
            targetCountry.setAttribute('inert', 'true');
            isFullFilter = false;
        }
    });

    targetCountry.addEventListener('change', () => {
        getPaymentMethods();
    });

    paymentType.addEventListener('change', () => {
        getPaymentMethods();
    });

    document.querySelectorAll('.ns-shop__clear').forEach(e => {
        e.addEventListener('click', () => {
            const industryChecked = industry.querySelector('input:checked');

            if (industryChecked) {
                industry.querySelector('input:checked').checked = false;
                industryTitle.textContent = industryTitle.dataset.title;
            }

            const targetRegionsChecked = targetRegion.querySelectorAll('input:checked');

            if (targetRegionsChecked) {
                for (const targetRegionChecked of targetRegionsChecked) {
                    targetRegionChecked.click();
                }
            }

            const paymentTypesChecked = paymentType.querySelectorAll('input:checked');

            if (paymentTypesChecked) {
                for (const paymentTypeChecked of paymentTypesChecked) {
                    paymentTypeChecked.click();
                }
            }

            const industryCheckedMobile = industryMobile.querySelector('input:checked');

            if (industryCheckedMobile) {
                industryCheckedMobile.checked = false;
            }

            const targetRegionsCheckedMobile = targetRegionMobile.querySelectorAll('input:checked');

            if (targetRegionsCheckedMobile) {
                for (const targetRegionCheckedMobile of targetRegionsCheckedMobile) {
                    targetRegionCheckedMobile.click();
                }
            }

            const paymentTypesCheckedMobile = paymentTypeFrameMobile.querySelectorAll('input:checked');

            if (paymentTypesCheckedMobile) {
                for (const paymentTypeCheckedMobile of paymentTypesCheckedMobile) {
                    paymentTypeCheckedMobile.click();
                }
            }
        });
    });

    const handleChangeRegions = () => {
        const tabs = targetCountryFrameMobile.querySelectorAll('.ns-multiselect-mobile__frame-tab');
        let activeRegion = null;

        for (const tab of tabs) {
            const isChecked = targetRegionMobile.querySelector(`.ns-checkbox__input[value='${tab.dataset.region}']:checked`);
            const items = targetCountryFrameMobile.querySelectorAll(`.ns-multiselect-mobile__frame-list-item[data-region='${tab.dataset.region}']`);

            if (isChecked) {
                tab.style.display = 'list-item';

                if (!activeRegion) {
                    tab.classList.add('ns-multiselect-mobile__frame-tab--active');

                    for (const item of items) {
                        const input = item.querySelector('.ns-checkbox__input');

                        if (!input.checked) {
                            input.click();
                        }

                    item.style.display = 'list-item';
                }

                activeRegion = tab.dataset.region;
            } else {
                tab.classList.remove('ns-multiselect-mobile__frame-tab--active');

                for (const item of items) {
                    const input = item.querySelector('.ns-checkbox__input');

                    if (!input.checked) {
                        input.click();
                    }

                    item.style.display = 'none';
                }
            }
        } else {
            tab.classList.remove('ns-multiselect-mobile__frame-tab--active');
            tab.style.display = 'none';

            for (const item of items) {
                const input = item.querySelector('.ns-checkbox__input');

                if (input.checked) {
                    input.click();
                }

                item.style.display = 'none';
            }
        }
    }
}

const handleChangeMainFilters = () => {
    const countIndustriesChecked = industryMobile.querySelectorAll('.ns-radio__input:checked').length;
    const countTargetRegionsChecked = targetRegionMobile.querySelectorAll('.ns-checkbox__input:checked').length;

    if (countIndustriesChecked && countTargetRegionsChecked) {
        targetCountryMobile.classList.remove('ns-multiselect-mobile--disabled');
        targetCountryMobile.removeAttribute('inert');
        paymentTypeMobile.classList.remove('ns-multiselect-mobile--disabled');
        paymentTypeMobile.removeAttribute('inert');
        buttonShowAllMobile.classList.remove('ns-button_disabled');
        buttonShowAllMobile.removeAttribute('inert');
    } else {
        buttonShowAllMobile.classList.add('ns-button_disabled');
        buttonShowAllMobile.setAttribute('inert', 'true');
        paymentTypeMobile.classList.add('ns-multiselect-mobile--disabled');
        paymentTypeMobile.setAttribute('inert', 'true');
        targetCountryMobile.classList.add('ns-multiselect-mobile--disabled');
        targetCountryMobile.setAttribute('inert', 'true');
    }
};

for (const industryMobileInput of industryMobileInputs) {
    industryMobileInput.addEventListener('change', handleChangeMainFilters)
}

for (const targetRegionMobileInput of targetRegionMobileInputs) {
    targetRegionMobileInput.addEventListener('change', () => {
        handleChangeMainFilters();
        handleChangeRegions();
    });
}

    const initMobileFilter = () => {
        const $openButton = document.querySelector(
            ".ns-customer-stories__mobile-open"
        );
        const $clearButton = document.querySelector(
            ".ns-customer-stories__mobile-controls .ns-customer-stories__clear"
        );

        const fields = containerMobile.querySelectorAll(".ns-multiselect");
        const $containerClearFilter = containerMobile.querySelector(
            ".ns-customer-stories-mobile-filter__clear"
        );
        const $closeButton = containerMobile.querySelector(
            ".ns-customer-stories-mobile-filter__close"
        );
        const $form = containerMobile.querySelector(
            ".ns-customer-stories-mobile-filter__form"
        );
        const industryMobileButton = document.querySelector('.ns-singleselect-mobile__title[data-tag="industry"]');
        const targetRegionMobileButton = document.querySelector('.ns-multiselect-mobile__title[data-tag="targetRegion"]');
        const targetCountryMobileButton = document.querySelector('.ns-multiselect-mobile__title[data-tag="targetCountry"]');
        const paymentTypeMobileButton = document.querySelector('.ns-multiselect-mobile__title[data-tag="paymentType"]');
        const backToFilterListSingleselect = document.querySelector('.ns-singleselect-mobile__frame-top-back');
        const backToFilterListMultiselect = document.querySelectorAll('.ns-multiselect-mobile__frame-top-back');
        const singleselectMobileFrameConfirmButtom = document.querySelector('.ns-singleselect-mobile__frame-confirm');
        const multiselectMobileFrameConfirmButtom = document.querySelectorAll('.ns-multiselect-mobile__frame-confirm');


        const handleOpen = () => {
            inertOnModalOn();
            containerMobile.classList.add("ns-customer-stories-mobile-filter--active");
            document.body.style.overflowY = 'hidden';
        };

        const handleClose = () => {
            inertOnModalOff();
            containerMobile.classList.remove(
                "ns-customer-stories-mobile-filter--active"
            );
            document.body.style.overflowY = 'visible';
        };

        const inertOnModalOn = () => {
            // inert on site root elements
            const firstLevelBodyNodes = document.querySelectorAll('body > *');
            firstLevelBodyNodes.forEach((node) => {
                node.setAttribute('inert', 'true');
            });
            const firstLevelMainNodes = document.querySelectorAll('.ns-main > *');
            firstLevelMainNodes.forEach((node) => {
                node.setAttribute('inert', 'true');
            });
            const firstLevelContentNodes = document.querySelectorAll('.ns-content > *');
            firstLevelContentNodes.forEach((node) => {
                node.setAttribute('inert', 'true');
            });
            const filterRootContainerElements = document.querySelectorAll("section.store__container > div > *:not(.ns-customer-stories-mobile-filter)");
            // inert on non-modal filter elements
            filterRootContainerElements.forEach((node) => {
                node.setAttribute('inert', 'true');
            });
            // clear inert on modal tree
            const mobileFilterContainer = document.querySelector(".ns-customer-stories-mobile-filter");
            let mobileFilterParentNode = mobileFilterContainer.parentNode;
            while(mobileFilterParentNode.nodeName !== "BODY"){
                console.dir(mobileFilterParentNode);
                mobileFilterParentNode.removeAttribute('inert');
                mobileFilterParentNode = mobileFilterParentNode.parentNode;
            }
            // focus on first modal element
            document.querySelector(".ns-customer-stories-mobile-filter__close").focus();
        };

        const inertOnModalOff = () => {
            const firstLevelBodyNodes = document.querySelectorAll('body > *');
            firstLevelBodyNodes.forEach((node) => {
                node.removeAttribute('inert');
            });
            const firstLevelMainNodes = document.querySelectorAll('.ns-main > *');
            firstLevelMainNodes.forEach((node) => {
                node.removeAttribute('inert');
            });
            const firstLevelContentNodes = document.querySelectorAll('.ns-content > *');
            firstLevelContentNodes.forEach((node) => {
                node.removeAttribute('inert');
            });
            const filterRootContainerElements = document.querySelectorAll("section.store__container > div > *:not(.ns-customer-stories-mobile-filter)");
            // inert on non-modal filter elements
            filterRootContainerElements.forEach((node) => {
                node.removeAttribute('inert');
            });
        };

        const handleDropFilters = () => {
            fields.forEach(($field) => {
                $field.dispatchEvent(new CustomEvent("handle-clear-value"));
            });
        };

        const handleClear = () => {
            handleDropFilters()

            onSubmitForm()
        }

        industryMobileButton.addEventListener("click",(e) => {
            inertOnOpenMobileTab(e.target);
        });
        targetRegionMobileButton.addEventListener("click",(e) => {
            inertOnOpenMobileTab(e.target);
        });
        targetCountryMobileButton.addEventListener("click",(e) => {
            inertOnOpenMobileTab(e.target);
        });
        paymentTypeMobileButton.addEventListener("click",(e) => {
            inertOnOpenMobileTab(e.target);
        });
        backToFilterListSingleselect.addEventListener("click",(e) => {
            const target = document.querySelector(`.ns-singleselect-mobile__title[data-tag="${e.target.parentNode.parentNode.dataset.tag}"]`);
            removeInertOnCloseMobileTab(target);
        });
        backToFilterListMultiselect.forEach((button)=>{
            button.addEventListener("click",(e) => {
                let tag = "";
                if(e.target.parentNode.parentNode.parentNode.classList.contains("ns-multiselect-mobile__frame--big")){
                    tag = e.target.parentNode.parentNode.parentNode.dataset.tag;
                }
                else{
                    tag = e.target.parentNode.parentNode.dataset.tag;
                }
                const target = document.querySelector(`.ns-multiselect-mobile__title[data-tag="${tag}"]`);
                removeInertOnCloseMobileTab(target);
            });
        });
        singleselectMobileFrameConfirmButtom.addEventListener("click",(e) => {
            const target = document.querySelector(`.ns-singleselect-mobile__title[data-tag="${e.target.parentNode.dataset.tag}"]`);
            removeInertOnCloseMobileTab(target);
        });
        multiselectMobileFrameConfirmButtom.forEach((button)=>{
            button.addEventListener("click",(e) => {
                const target = document.querySelector(`.ns-multiselect-mobile__title[data-tag="${e.target.parentNode.dataset.tag}"]`);
                removeInertOnCloseMobileTab(target);
            });
        });

        const inertOnOpenMobileTab = (target) => {
            target.parentNode.parentNode.parentNode.parentNode.setAttribute('inert', 'true');
        };

        const removeInertOnCloseMobileTab = (target) => {
            target.parentNode.parentNode.parentNode.parentNode.removeAttribute('inert');
            target.focus();
        };

        const handleSubmit = e => {
            if (e.target.classList.contains('ns-button_disabled')) {
                return;
            }

            const industryMobileValue = encodeURIComponent(industryMobile.querySelector('.ns-radio__input:checked').value);
            let targetRegionMobileValue = '';

            for (const regionChecked of targetRegionMobile.querySelectorAll('.ns-checkbox__input:checked')) {
                if (targetRegionMobileValue === '') {
                    targetRegionMobileValue = regionChecked.value;
                } else {
                    targetRegionMobileValue += `,${regionChecked.value}`;
                }
            }

            targetRegionMobileValue = encodeURIComponent(targetRegionMobileValue);
            let targetCountryMobileValue = '';

            for (const countryChecked of targetCountryFrameMobile.querySelectorAll('.ns-checkbox__input:checked')) {
                if (targetCountryMobileValue === '') {
                    targetCountryMobileValue = countryChecked.value;
                } else {
                    targetCountryMobileValue += `,${countryChecked.value}`;
                }
            }

            targetCountryMobileValue = encodeURIComponent(targetCountryMobileValue);
            let paymentTypeMobileValue = '';

            for (const paymentTypeChecked of paymentTypeFrameMobile.querySelectorAll('.ns-checkbox__input:checked')) {
                if (paymentTypeMobileValue === '') {
                    paymentTypeMobileValue = paymentTypeChecked.value;
                } else {
                    paymentTypeMobileValue += `,${paymentTypeChecked.value}`;
                }
            }

            paymentTypeMobileValue = encodeURIComponent(paymentTypeMobileValue);
            const path = buttonShowAllDesktop.dataset.path;
            window.location.href = `${path}?businessType=${industryMobileValue}&targetRegions=${targetRegionMobileValue}&targetCountries=${targetCountryMobileValue}&paymentDirection=${paymentTypeMobileValue}`;
        };

        $openButton.addEventListener("click", handleOpen);

        $closeButton.addEventListener("click", handleClose);

        buttonShowAllMobile.addEventListener('click', e => handleSubmit(e));
    };

    initMobileFilter();

    const getPaymentMethods = () => {
        const businessType = encodeURIComponent(industryInput.value);
        const targetRegions = encodeURIComponent(targetRegionSelectInput.value);
        const targetCountries = encodeURIComponent(targetCountry.querySelector('.ns-multiselect__input').value);
        const paymentDirection = encodeURIComponent(paymentType.querySelector('.ns-multiselect__input').value);
        buttonShowAllDesktop.href = `${buttonShowAllDesktop.dataset.path}?businessType=${businessType}&targetRegions=${targetRegions}&targetCountries=${targetCountries}&paymentDirection=${paymentDirection}`;
    };
};

window.addEventListener("DOMContentLoaded", init, false);
